import React, { useContext, useEffect, useState } from "react";
import axios from "axios";

const AppContext = React.createContext();

const AppProvider = ({ children }) => {

    const baseURl = 'https://api.foodgrade.co.nz/';
    const searchUrl = `${baseURl}search?keyword=`;
    const shamelistUrl = `${baseURl}shamelist`;

    const [premisesList, setPremisesList] = useState([]);
    const [shameList, setShameList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchKeyword, setSearchKeyword] = useState('');

    const searchPremises = async (url) => {
        setLoading(true);
        try {
            const { data } = await axios(url);

            if (data) {
                setPremisesList(data);
            } else {
                setPremisesList([]);
            }
        } catch (e) {
            setPremisesList([]);
        }
        setLoading(false);
    }

    const retrieveShameList = async () => {
        if (!shameList.length) {

            setLoading(true);
            try {
                const { data } = await axios(shamelistUrl);

                if (data) {
                    setShameList(data);
                } else {
                    setShameList([]);
                }
            } catch (e) {
                setShameList([]);
            }
            setLoading(false);
        }
    }


    useEffect(() => {
        if (!searchKeyword)
            return;
        localStorage.setItem('searchKeyword', searchKeyword);
        searchPremises(`${searchUrl}${searchKeyword}`);
    }, [searchKeyword, searchUrl]);

    const clearSaveSearchTerm = () => {
        setSearchKeyword('');
        setPremisesList([]);
        localStorage.removeItem('searchKeyword');
    }

    return (
        <AppContext.Provider value={{
            premisesList,
            loading,
            searchKeyword,
            setSearchKeyword,
            clearSaveSearchTerm,
            shameList,
            retrieveShameList
        }}>
            {children}
        </AppContext.Provider>
    )
}

export const useGlobalContext = () => {
    return useContext(AppContext);
}

export { AppContext, AppProvider }